module.exports = __webpack_public_path__ + "assets/img/adver_icon.cabbf063.png";